export class SubscribeModel {
    constructor(id, userId, planName, planDetailId, planValidity) {
        this.id = id;
        this.userId = userId;
        this.planName = planName;
        this.planDetailId = planDetailId;
        this.planValidity = planValidity;

    }
}